import { RouteConfig } from 'vue-router';

import Sports from '@/views/sport/List.vue';

export const sportsRoute: RouteConfig = {
  name: 'sports',
  path: 'sports',
  component: Sports,
  meta: {
    authorized: true,
    breadcrumb: {
      title: 'breadcrumbs.sports.list'
    },
    config: {
      title: 'menu.sports',
      icon: 'fa-dumbbell',
      permissions: ['SPORT.LIST', 'SPORT.ADD'],
      group: 'Ustawienia'
    }
  }
};
